import { isSafeCookiePart } from '../../utils/cookieValidation';

const SECURE_COOKIE_ATTRIBUTES = 'Secure; SameSite=Lax; Path=/';

export function setBrowserCookie(name: string, value: string): void {
    if (!isSafeCookiePart(name) || !isSafeCookiePart(value)) {
        return;
    }
    document.cookie = `${name}=${value}; ${SECURE_COOKIE_ATTRIBUTES}`;
}

export function deleteBrowserCookie(name: string): void {
    if (!isSafeCookiePart(name)) {
        return;
    }
    document.cookie = `${name}=; Max-Age=0; ${SECURE_COOKIE_ATTRIBUTES}`;
}
